(function () {
  function toArray(nodes) {
    return Array.prototype.slice.call(nodes || []);
  }

  function setHidden(node, hidden) {
    if (!node) return;
    node.hidden = hidden;
  }

  function initJournalFilters(scope) {
    var roots = toArray(scope.querySelectorAll('[data-fs-journal-filters]'));
    if (!roots.length) return;

    roots.forEach(function (root) {
      if (root.dataset.fsJournalBound === 'true') return;

      var section = root.closest('.fs-journal');
      if (!section) return;

      var buttons = toArray(root.querySelectorAll('[data-filter]'));
      var cards = toArray(section.querySelectorAll('[data-fs-journal-grid] .fs-journal-card'));
      var featured = section.querySelector('[data-fs-journal-featured]');
      var emptyState = section.querySelector('[data-fs-journal-empty]');
      var filterValues = buttons.map(function (button) {
        return button.getAttribute('data-filter') || '';
      });

      if (!buttons.length) return;

      function applyFilter(value) {
        var nextValue = filterValues.indexOf(value) > -1 ? value : 'all';
        var visibleCards = 0;

        buttons.forEach(function (button) {
          var isActive = button.getAttribute('data-filter') === nextValue;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        cards.forEach(function (card) {
          var category = card.getAttribute('data-category') || '';
          var isVisible = nextValue === 'all' || category === nextValue;
          setHidden(card, !isVisible);
          if (isVisible) visibleCards += 1;
        });

        if (featured) {
          var featuredCategory = featured.getAttribute('data-category') || '';
          var showFeatured = nextValue === 'all' || featuredCategory === nextValue;
          setHidden(featured, !showFeatured);
        }

        if (emptyState) {
          var featuredVisible = featured ? featured.hidden !== true : false;
          setHidden(emptyState, visibleCards > 0 || featuredVisible);
        }
      }

      root.addEventListener('click', function (event) {
        var button = event.target.closest('[data-filter]');
        if (!button || !root.contains(button)) return;

        applyFilter(button.getAttribute('data-filter') || 'all');
      });

      root.dataset.fsJournalBound = 'true';
      applyFilter('all');
    });
  }

  function initAll(scope) {
    var context = scope && scope.querySelector ? scope : document;
    initJournalFilters(context);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
